import type { ReactNode } from 'react';
import type { SpotlightProps } from '@atlaskit/onboarding/types';

export const childrenTranslation = (value: SpotlightProps['children']): ReactNode => {
	return value;
};
